import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=468aecb5&"
import script from "./Footer.vue?vue&type=script&setup=true&lang=js&"
export * from "./Footer.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=468aecb5&prod&lang=scss&socped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports